var exports = {
  "zr": "IncomingCallUI.module__root___UFJ5aX",
  "Nr": "IncomingCallUI.module__card___UFJ5aX",
  "BU": "IncomingCallUI.module__dragHandle___UFJ5aX",
  "IH": "IncomingCallUI.module__dragPill___UFJ5aX",
  "t$": "IncomingCallUI.module__stack___UFJ5aX",
  "wx": "IncomingCallUI.module__header___UFJ5aX",
  "nr": "IncomingCallUI.module__headerIcon___UFJ5aX",
  "my": "IncomingCallUI.module__avatar___UFJ5aX",
  "_0": "IncomingCallUI.module__ic-ring-pulse___UFJ5aX",
  "sI": "IncomingCallUI.module__callerInfo___UFJ5aX",
  "XF": "IncomingCallUI.module__callerName___UFJ5aX",
  "_n": "IncomingCallUI.module__callerSubtitle___UFJ5aX",
  "o1": "IncomingCallUI.module__actions___UFJ5aX",
  "mH": "IncomingCallUI.module__actionGroup___UFJ5aX",
  "T$": "IncomingCallUI.module__circleButton___UFJ5aX",
  "FM": "IncomingCallUI.module__circleButtonAccept___UFJ5aX",
  "cK": "IncomingCallUI.module__circleButtonReject___UFJ5aX",
  "V6": "IncomingCallUI.module__circleButtonIconRotated___UFJ5aX",
  "ZJ": "IncomingCallUI.module__actionLabel___UFJ5aX",
  "rw": "IncomingCallUI.module__ignoreLink___UFJ5aX",
  "IR": "IncomingCallUI.module__screenReaderOnly___UFJ5aX",
  "Po": "IncomingCallUI.module__bottomSheetStack___UFJ5aX",
};

module.exports = exports;
